import { IMediaFileInfo, IMenuEditModel, ITag } from 'AppTypes'

export class MenuEditModel implements IMenuEditModel {
  id: string = ''

  storeId: string = ''

  menuTypeId: string = ''

  menuName: string = ''

  price: number = 0

  priceSale: number = 0

  isActive: boolean = true

  isPublish: boolean = false

  orderNumber: number = 0

  video?: IMediaFileInfo

  images: IMediaFileInfo[] = []

  imageIdDelete: string[] = []

  type: number = 0

  description: string = ''

  tags: string[] = []

  allergens: string[] = []

  createdAtUtc: Date = new Date()

  updatedAtUtc: Date = new Date()
}
